import { InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useSearchParams } from "@/hooks/useSearchParams";
import { useCallback, useEffect, useState } from "react";
import { useGetPaymentAccountsQuery } from "@/features/app/appApiSlice";
import { handleError } from "@/utils/handleError";
import { IPaymentAccountItem } from "@/features/app/types";
import { ISelectPaymentParams } from "@/types/base";
import * as Styled from "./SelectPaymentAccount.styles";

export interface ISelectPaymentAccountParams {
  paymentAccountType: string;
}

const PaymentAccountSelectLabel = "Payment Account";

export const SelectPaymentAccount = () => {
  const [paymentAccounts, setPaymentAccounts] = useState<
    Array<IPaymentAccountItem>
  >([]);
  const { data, isFetching, error } = useGetPaymentAccountsQuery();
  const { paymentAccounts: defaultOptions = [] } = data || {};

  const { parsedSearchParams, mergeSearchParams } =
    useSearchParams<ISelectPaymentParams>();
  const { paymentAccountType, merchant } = parsedSearchParams || "";

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error]);

  useEffect(() => {
    if (paymentAccounts?.length && !paymentAccountType) {
      mergeSearchParams({
        paymentAccountType: paymentAccounts[0].ppaName,
      });
    }
  }, [mergeSearchParams, paymentAccountType, paymentAccounts]);

  useEffect(() => {
    if (merchant) {
      const filteredOptions =
        defaultOptions.filter(
          (item: IPaymentAccountItem) =>
            item.merchantId.toString() === merchant,
        ) || [];
      setPaymentAccounts(filteredOptions);
      const existOption = filteredOptions.find(
        (item: IPaymentAccountItem) => item.ppaName == paymentAccountType,
      );

      if (filteredOptions?.length && !existOption) {
        mergeSearchParams({
          paymentAccountType: filteredOptions[0].ppaName,
        });
      }
    }
  }, [merchant, mergeSearchParams, defaultOptions, paymentAccountType]);

  const handlePaymentAccountChange = useCallback(
    (event: SelectChangeEvent) => {
      mergeSearchParams({
        paymentAccountType: event?.target.value,
      });
    },
    [mergeSearchParams],
  );

  return (
    <Styled.FormControl disabled={isFetching}>
      <InputLabel>{PaymentAccountSelectLabel}</InputLabel>
      <Select
        value={paymentAccountType || ""}
        label={PaymentAccountSelectLabel}
        onChange={handlePaymentAccountChange}
      >
        {paymentAccounts?.map((option: IPaymentAccountItem) => (
          <MenuItem key={option.ppaId} value={option.ppaName}>
            {option.ppaName}
          </MenuItem>
        ))}
      </Select>
    </Styled.FormControl>
  );
};
